import React, { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Grid, Typography, useTheme, Divider } from "@mui/material";
import CommonCard from "../../common/components/CommonCard";
import CommonButton from "../../common/components/CommonButton";
import { ArrowRight } from "@mui/icons-material";

const CollegeList = ({
    colleges,
    aiColleges
}) => {
    const theme = useTheme();
    const navigate = useNavigate();
    
    return (
        <Fragment>
            <Grid item xs={12} md={2.5}>
                <CommonCard
                    borderRadius={2}
                    headerContent={
                        <Fragment>
                            <Box sx={{ padding: '17.5px 13px' }}>
                                <Typography fontWeight={600}>My Dream Colleges</Typography>
                            </Box>
                            <Divider />
                        </Fragment>
                    }
                    content={
                        <Fragment>
                            {colleges.filter((a) => a.list_type === 'DREAM').length > 0 ? colleges.filter((a) => a.list_type === 'DREAM').slice(0, 1).map((i, index) => (
                                <CommonCard
                                    key={index}
                                    content={
                                        <Fragment>
                                            <img src={i?.college?.logo_url || '/Images/college_1.png'} alt="college" width='100%' height="130px" />
                                            <Box display="flex" justifyContent="space-between" p={0.9}>
                                                <Box width='80%'>
                                                    <Typography fontWeight={600} fontSize={14}>{i?.college?.college_name}</Typography>
                                                    <Box display="flex" gap={0.3} mt={0.8} alignItems='center'>
                                                        <img src="/Images/location.png" alt="location" width="17px" height="17px" />
                                                        <Typography fontSize={14} color={theme.palette.background.dark}>{`${i?.college?.city}, ${i?.college?.state} ${i?.college?.zipcode}`}</Typography>
                                                    </Box>
                                                </Box>
                                                <img src="/Images/dream.png" alt="dream college" height="50px" />
                                            </Box>
                                        </Fragment>
                                    }
                                    border={`1px solid ${theme.palette.background.light}`}
                                    borderRadius={1}
                                    paddingBottom="0px"
                                    padding="0px"
                                    marginTop="0px"
                                />
                            ))  : aiColleges?.dream_college?.length > 0 ? aiColleges?.dream_college.map((i, index) => (
                                <Grid item md={6}>
                                    <CommonCard
                                        key={index}
                                        content={
                                            <Fragment>
                                                <img 
                                                    src={i?.logo_url || '/Images/college_1.png'} 
                                                    alt="college" 
                                                    width='100%' 
                                                    height="130px" 
                                                />
                                                <Box display="flex" justifyContent="space-between" p={0.9}>
                                                    <Box width='80%'>
                                                        <Typography fontWeight={600} fontSize={14}>{i?.college_name}</Typography>
                                                        <Box display="flex" gap={0.3} mt={0.8} alignItems='center'>
                                                            <img src="/Images/location.png" alt="location" width="17px" height="17px" />
                                                            <Typography fontSize={14} color={theme.palette.background.dark}>{`${i?.city}, ${i?.state} ${i?.zipcode}`}</Typography>
                                                        </Box>
                                                    </Box>
                                                    <img src="/Images/dream.png" alt="dream college" height="50px" />
                                                </Box>
                                                <Box sx={{ float: 'right', marginRight: 1 }}>
                                                    <CommonButton
                                                        marginTop={0.5}
                                                        height="20px"
                                                        marginBottom="10px"
                                                        label="Recommended by DCP AI"
                                                        width="170px"
                                                        fontSize="12px"
                                                        borderRadius="5px"
                                                        fontWeight={600}
                                                    />
                                                </Box>
                                            </Fragment>
                                        }
                                        border={`1px solid ${theme.palette.background.light}`}
                                        borderRadius={1}
                                        paddingBottom="0px"
                                        padding="0px"
                                        marginTop="0px"
                                    />
                                </Grid>
                            )) :
                                <Box textAlign="center">
                                    <Typography color={theme.palette.background.dark}>No College Found</Typography>
                                </Box>
                            }
                        </Fragment>
                    }
                    paddingBottom="0px"
                    padding="13px"
                    marginTop="0px"
                />
            </Grid>
            <Grid item xs={12} md={4.75}>
                <CommonCard
                    borderRadius={2}
                    headerContent={
                        <Fragment>
                            <Box p={1.5} display="flex" justifyContent="space-between" alignItems="center">
                                <Typography fontWeight={600}>My Target Colleges</Typography>
                                <CommonButton
                                    label="Explore More"
                                    marginBottom="0px"
                                    background={theme.palette.secondary.main}
                                    color={theme.palette.primary.main}
                                    width="150px"
                                    height="35px"
                                    endIcon={<ArrowRight />}
                                    handleClick={() => navigate('/colleges')}
                                />
                            </Box>
                            <Divider />
                        </Fragment>
                    }
                    content={
                        <Fragment>
                            <Grid container spacing={2}>
                                {colleges.filter((a) => a.list_type === 'TARGET').length > 0 ? colleges.filter((a) => a.list_type === 'TARGET').slice(0, 2).map((i, index) => (
                                    <Grid item md={6}>
                                        <CommonCard
                                            key={index}
                                            content={
                                                <Fragment>
                                                    <img src={i?.college?.logo_url || '/Images/college_1.png'} alt="college" width='100%' height="130px" />
                                                    <Box display="flex" justifyContent="space-between" p={0.9}>
                                                        <Box width='80%'>
                                                            <Typography fontWeight={600} fontSize={14}>{i?.college?.college_name}</Typography>
                                                            <Box display="flex" gap={0.3} mt={0.8} alignItems='center'>
                                                                <img src="/Images/location.png" alt="location" width="17px" height="17px" />
                                                                <Typography fontSize={14} color={theme.palette.background.dark}>{`${i?.college?.city}, ${i?.college?.state} ${i?.college?.zipcode}`}</Typography>
                                                            </Box>
                                                        </Box>
                                                        <img src="/Images/target.png" alt="dream college" height="50px" />
                                                    </Box>
                                                </Fragment>
                                            }
                                            border={`1px solid ${theme.palette.background.light}`}
                                            borderRadius={1}
                                            paddingBottom="0px"
                                            padding="0px"
                                            marginTop="0px"
                                        />
                                    </Grid>
                                )) : aiColleges?.target_colleges?.length > 0 ? aiColleges?.target_colleges.map((i, index) => (
                                    <Grid item md={6}>
                                        <CommonCard
                                            key={index}
                                            content={
                                                <Fragment>
                                                    <img 
                                                        src={i?.logo_url || '/Images/college_1.png'} 
                                                        alt="college" 
                                                        width='100%' 
                                                        height="130px"
                                                    />
                                                    <Box display="flex" justifyContent="space-between" p={0.9}>
                                                        <Box width='80%'>
                                                            <Typography fontWeight={600} fontSize={14}>{i?.college_name}</Typography>
                                                            <Box display="flex" gap={0.3} mt={0.8} alignItems='center'>
                                                                <img src="/Images/location.png" alt="location" width="17px" height="17px" />
                                                                <Typography fontSize={14} color={theme.palette.background.dark}>{`${i?.city}, ${i?.state} ${i?.zipcode}`}</Typography>
                                                            </Box>
                                                        </Box>
                                                        <img src="/Images/target.png" alt="dream college" height="50px" />
                                                    </Box>
                                                    <Box sx={{ float: 'right', marginRight: 1 }}>
                                                        <CommonButton
                                                            marginTop={0.5}
                                                            height="20px"
                                                            marginBottom="10px"
                                                            label="Recommended by DCP AI"
                                                            width="170px"
                                                            fontSize="12px"
                                                            borderRadius="5px"
                                                            fontWeight={600}
                                                        />
                                                    </Box>
                                                </Fragment>
                                            }
                                            border={`1px solid ${theme.palette.background.light}`}
                                            borderRadius={1}
                                            paddingBottom="0px"
                                            padding="0px"
                                            marginTop="0px"
                                        />
                                    </Grid>
                                )) : <Grid item md={12} textAlign="center">
                                    <Typography color={theme.palette.background.dark}>No College Found</Typography>
                                </Grid>}
                            </Grid>
                        </Fragment>
                    }
                    paddingBottom="0px"
                    padding="13px"
                    marginTop="0px"
                />
            </Grid>
            <Grid item xs={12} md={4.75}>
                <CommonCard
                    borderRadius={2}
                    headerContent={
                        <Fragment>
                            <Box p={1.5} display="flex" justifyContent="space-between" alignItems="center">
                                <Typography fontWeight={600}>My Safe Colleges</Typography>
                                <CommonButton
                                    label="Explore More"
                                    marginBottom="0px"
                                    background={theme.palette.secondary.main}
                                    color={theme.palette.primary.main}
                                    width="150px"
                                    height="35px"
                                    endIcon={<ArrowRight />}
                                    handleClick={() => navigate('/colleges')}
                                />
                            </Box>
                            <Divider />
                        </Fragment>
                    }
                    content={
                        <Fragment>
                            <Grid container spacing={2}>
                                {colleges.filter((a) => a.list_type === 'SAFE')?.length > 0 ? colleges.filter((a) => a.list_type === 'SAFE').slice(0, 2).map((i, index) => (
                                    <Grid item md={6}>
                                        <CommonCard
                                            key={index}
                                            content={
                                                <Fragment>
                                                    <img src={i?.college?.logo_url || '/Images/college_1.png'} alt="college" width='100%' height="130px" />
                                                    <Box display="flex" justifyContent="space-between" p={0.9}>
                                                        <Box width='80%'>
                                                            <Typography fontWeight={600} fontSize={14}>{i?.college?.college_name}</Typography>
                                                            <Box display="flex" gap={0.3} mt={0.8} alignItems='center'>
                                                                <img src="/Images/location.png" alt="location" width="17px" height="17px" />
                                                                <Typography fontSize={14} color={theme.palette.background.dark}>{`${i?.college?.city}, ${i?.college?.state} ${i?.college?.zipcode}`}</Typography>
                                                            </Box>
                                                        </Box>
                                                        <img src="/Images/safe.png" alt="dream college" height="50px" />
                                                    </Box>
                                                </Fragment>
                                            }
                                            border={`1px solid ${theme.palette.background.light}`}
                                            borderRadius={1}
                                            paddingBottom="0px"
                                            padding="0px"
                                            marginTop="0px"
                                        />
                                    </Grid>
                                )) : aiColleges?.safe_colleges?.length > 0 ? aiColleges?.safe_colleges.map((i, index) => (
                                    <Grid item md={6}>
                                        <CommonCard
                                            key={index}
                                            content={
                                                <Fragment>
                                                    <img src={i?.logo_url || '/Images/college_1.png'} alt="college" width='100%' height="130px" />
                                                    <Box display="flex" justifyContent="space-between" p={0.9}>
                                                        <Box width='80%'>
                                                            <Typography fontWeight={600} fontSize={14}>{i?.college_name}</Typography>
                                                            <Box display="flex" gap={0.3} mt={0.8} alignItems='center'>
                                                                <img src="/Images/location.png" alt="location" width="17px" height="17px" />
                                                                <Typography fontSize={14} color={theme.palette.background.dark}>{`${i?.city}, ${i?.state} ${i?.zipcode}`}</Typography>
                                                            </Box>
                                                        </Box>
                                                        <img src="/Images/safe.png" alt="dream college" height="50px" />
                                                    </Box>
                                                    <Box sx={{ float: 'right', marginRight: 1 }}>
                                                        <CommonButton
                                                            marginTop={0.5}
                                                            height="20px"
                                                            marginBottom="10px"
                                                            label="Recommended by DCP AI"
                                                            width="170px"
                                                            fontSize="12px"
                                                            borderRadius="5px"
                                                            fontWeight={600}
                                                        />
                                                    </Box>
                                                </Fragment>
                                            }
                                            border={`1px solid ${theme.palette.background.light}`}
                                            borderRadius={1}
                                            paddingBottom="0px"
                                            padding="0px"
                                            marginTop="0px"
                                        />
                                    </Grid>
                                )) : <Grid item md={12} textAlign="center">
                                    <Typography color={theme.palette.background.dark}>No College Found</Typography>
                                </Grid>
                                }
                            </Grid>
                        </Fragment>
                    }
                    paddingBottom="0px"
                    padding="13px"
                    marginTop="0px"
                />
            </Grid>
        </Fragment>
    )
}

export default CollegeList;